import type { Store } from "@reduxjs/toolkit";

import { PLUGIN_MULTI_FACTOR_AUTH } from "metabase/plugins";
import type { State } from "metabase/redux/store";
import { Route, type RouteComponent, redirect } from "metabase/router";

import { getNotificationRoutes } from "./notifications/routes";

/**
 * The account pages, in their own chunk. `IsAuthenticated` stays eager: it has
 * to decide before there is anything to show.
 */
const accountApp = () =>
  import("./app/containers/AccountApp").then(({ AccountApp }) => ({
    Component: AccountApp,
  }));

const userProfileApp = () =>
  import("./profile/containers/UserProfileApp").then((module) => ({
    Component: module.default,
  }));

const userPasswordApp = () =>
  import("./password/containers/UserPasswordApp").then((module) => ({
    Component: module.default,
  }));

const loginHistoryApp = () =>
  import("./login-history/containers/LoginHistoryApp").then((module) => ({
    Component: module.default,
  }));

export const getAccountRoutes = (
  _store: Store<State>,
  IsAuthenticated: RouteComponent,
) => {
  return (
    <Route path="/account" element={<IsAuthenticated />}>
      <Route lazy={accountApp}>
        <Route index element={redirect("profile")} />
        <Route path="profile" lazy={userProfileApp} />
        <Route path="password" lazy={userPasswordApp} />
        <Route
          path="security"
          element={<PLUGIN_MULTI_FACTOR_AUTH.AccountSecurityPanel />}
        />
        <Route path="login-history" lazy={loginHistoryApp} />
        {getNotificationRoutes()}
      </Route>
    </Route>
  );
};
